import axios from "axios"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { locationPageData } from "../../Blc_Api/BlcLocationPageData/LocationPageData"
import { useHomePagaData } from "../../Blc_Business/BlcHomeLandingPage/HomeWindowTwo"
import { useBlcLocations } from "../../Blc_Business/FristSixBLC/blcLocations"
import { useLocationPageData, useMyloc } from "../../Blc_Business/FristSixBLC/LocationsPageDataHandling"
import Blc_map from "../../Blc_Home/Blc_map/Blc_map"
import Hero_Section_Two from "./Hero_Section_Two"
import Our_Facilities from "./Our_Facilities"



const BlcSingleLocation = (props) => {
    const { locName } = useParams();

    // replacing (-) with whitespace(%20) from loc name in url 
    function locNameFormatting(str) {
        if (str.indexOf('-') >= 0) {
            return str.split('-').join(' ');
        }
        else {
            return str;
        }
    }

    const singleLoc = props.valData.filter(loc => loc.location_name === locNameFormatting(locName))[0];

    //  console.log(props.valData[props.valIndex]);


    return (
        <div>

            {/* <Hero_Section_Two valDataOne={props.valData[props.valIndex]} />
            <Our_Facilities valDataThree={props.valData[props.valIndex]} /> */}
            <Hero_Section_Two valDataOne={singleLoc} />
            <Our_Facilities valDataThree={singleLoc} />
            <Blc_map />
        </div>
    )
}


export default BlcSingleLocation;